export default __webpack_public_path__ + "static/media/inside_cabinets.962c50fe.svg";